import { path } from 'ramda';

export const selectLoading = path(['page', 'loading']);
export const selectHideFooter = path(['page', 'hideFooter']);
export const selectHideHeader = path(['page', 'hideHeader']);
